var map = {
	"./Rectangle.svg": 6487,
	"./c.svg": 5291,
	"./crochets.svg": 8971,
	"./css.svg": 349,
	"./favicon.png": 302,
	"./favicon.svg": 240,
	"./github.svg": 8149,
	"./github_light.svg": 7948,
	"./hi.svg": 281,
	"./html.svg": 8151,
	"./internet.svg": 3359,
	"./java.svg": 7032,
	"./linkedin.svg": 3817,
	"./linkedin_light.svg": 5507,
	"./mysql.svg": 9994,
	"./php.svg": 1456,
	"./position_icon.svg": 8660,
	"./position_light.svg": 336,
	"./rectangle.svg": 5175,
	"./send.svg": 1362,
	"./smiley.svg": 9901,
	"./vue.svg": 7624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9862;